import { workspaceLocation } from "../workspace-runtime";
import { organizationSlug } from "@knowledge/pages/urls";
import type { Organization } from "@knowledge/sync";

let organizations: Organization[] = [];
export function registerOrganizations(value: Organization[]) {
  organizations = value;
}
export function currentOrganizationId(): string | undefined {
  const slug = organizationSlug(workspaceLocation().pathname);
  return organizations.find((org) => org.slug === slug)?.id;
}
